<template>
  <v-card elevation="2" color="background" class="d-flex flex-column" style="height: 100%">
    <v-card-title>
      الهيكليات
      <v-spacer></v-spacer>

      <DefaultDialog
        :showAddButton="isCanCreate"
        buttonText="اضافة"
        title="اضافة نوع"
        :openToEdit="openToEdit"
        editTitle="تعديل نوع"
        :openToView="openToView"
        viewTitle="عرض البيانات"
        @onCloseDialog="onCloseDialog"
        :toggleSize="true"
      >
        <ContentTypeDetail
          slot-scope="{
            submitWithClose,
            submitWithNew,
            submitWithoutClose,
            closeDialog,
            isEdit,
            isView,
            isNew,
          }"
          :submitWithClose="submitWithClose"
          :submitWithNew="submitWithNew"
          :submitWithoutClose="submitWithoutClose"
          :setItemID="setItemID"
          :closeDialog="closeDialog"
          :afterSubmit="getData"
          :itemId="itemId"
          :isEdit="isEdit"
          :isView="isView"
          :isNew="isNew"
        />
      </DefaultDialog>
    </v-card-title>
    <v-card-text class="d-flex flex-column justify-space-between"
      style="flex: 1; min-height: 0">
      <!-- Filters -->
      <v-row style="flex: 0">
        <!-- <v-col cols="12" md="12">
          <v-text-field
            v-model="options.title"
            flat
            hide-details="auto"
            label="بحث"
            outlined
            prepend-inner-icon="mdi-magnify"
            solo
          ></v-text-field>
        </v-col> -->
        <v-col cols="12">
          <languages-filter @change="changeLanguage" />
        </v-col>
      </v-row>

      <!-- Grid -->
      <v-row class="mt-0" style="min-height: 0">
        <v-col cols="12" style="flex: auto; min-height: 0; height: 100%">
          <v-data-table
            class="elevation-1"
            :headers="headers"
            :items="contentTypes"
            :items-per-page="options.pageSize"
            :loading="$store.state.loading.show"
            :ripple="false"
            fixed-header
            hide-default-footer
            height="100%"
            style="height: 100%; overflow: auto"
            loading-text="جار التحميل..."
            no-data-text="لا يوجد"
          >
            <template v-slot:[`item.controls`]="props">
              <template v-if="isCanRead">
                <v-btn
                  small
                  color="#78b200"
                  @click="viewRow(props.item)"
                  class="mr-1"
                >
                  <v-icon color="#fff">mdi-eye</v-icon>
                </v-btn>
              </template>

              <template v-if="isCanUpdate">
                <v-btn
                  small
                  color="#ffa000"
                  @click="editRow(props.item)"
                  class="mr-1"
                >
                  <v-icon color="#fff">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>

              <template v-if="isCanDelete">
                <v-btn
                  small
                  color="pink"
                  @click="deleteRow(props.item)"
                  class="mr-1"
                >
                  <v-icon color="#fff">mdi-delete</v-icon>
                </v-btn>
              </template>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <!-- pagination -->
      <v-row class="mt-0" style="flex: 0">
        <v-col cols="12" class="d-flex justify-space-between align-center">
          <v-pagination v-model="options.pageIndex" :length="numberOfPages" />
          <v-select
            v-model="options.pageSize"
            :items="[5, 10, 15, 20]"
            label="عدد الصفوف"
            solo
            dense
            hide-details
            item-color="white"
            class="flex-grow-0"
            style="width: 100px"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import qs from 'qs';
import LanguagesFilter from '@/components/LanguagesFilter.vue';
import { selectedLanguage } from '@/config/config';
import DefaultDialog from '@/components/DefaultDialog.vue';
import ContentTypeDetail from '../contentType/crud/ContentTypeDetail.vue';

import { mapActions } from 'vuex';
import { showSnackbarFailMessage } from '@/utls/snackbar';
import PermissionMixin from '@/mixins/PermissionMixin';
import { appPermissions } from '@/libs/auth/permissions/appPermissions';

export default {
  components: {
    LanguagesFilter,
    ContentTypeDetail,
    DefaultDialog,
  },
  mixins: [PermissionMixin(appPermissions.contentType)],
  data() {
    return {
      sel: null,
      contentTypes: [],
      total: 0,
      headers: [
        { text: 'slug', value: 'slug' },
        { text: 'الأسم', value: 'language.name' },
        { text: '', value: 'controls', sortable: false },
      ],
      options: {
        pageIndex: 1,
        pageSize: 15,
        language: selectedLanguage,
        title: '',
      },
      // for view edit and detail
      // ------------------------
      openToEdit: false,
      openToView: false,
      itemId: null,
      // ------------------------
    };
  },
  computed: {
    skipPerPage() {
      return this.options.pageSize * (this.options.pageIndex - 1);
    },
    numberOfPages() {
      const pages = Math.ceil(this.total / this.options.pageSize) || 1;
      return pages;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      loadMenuTypes: 'entriesTypeMenu/loadTypes',
      openConfirm: 'confirm/openConfirm',
    }),
    deleteRow(item) {
      this.openConfirm({
        message: 'هل انت متأكد من حذف النوع ؟',
        confirm: () => {
          return this.$http
            .delete('app/content-type/' + item.id, {})
            .then(() => {
              this.getData();
              return true;
            })
            .catch((error) => {
              showSnackbarFailMessage('حدث خطأ اثناء عملية الحذف');
              return false;
            })
            .finally(() => {
              this.loadMenuTypes();
            });
        },
      });
    },
    onCloseDialog() {
      this.openToEdit = false;
      this.openToView = false;
    },
    editRow(item) {
      this.openToEdit = true;
      this.itemId = item.id;
    },
    viewRow(item) {
      this.openToView = true;
      this.itemId = item.id;
    },
    setItemID(id) {
      if (id) return this.editRow({ id });
      this.itemId = null;
      this.onCloseDialog();
    },
    changeLanguage(language) {
      this.options.language = language;
    },
    getData() {
      this.$store.commit('loading/SET_SHOW', true);

      const requestConfig = {
        params: {
          skipCount: this.skipPerPage,
          maxResultCount: this.options.pageSize,
          language: this.options.language,
          title: this.options.title,
        },
        paramsSerializer: function (params) {
          const queryString = qs.stringify(params, { arrayFormat: 'brackets' });
          return queryString;
        },
      };

      this.$http
        .get('app/content-type', requestConfig)
        .then((response) => {
          const { items, totalCount } = response.data;

          const resultData = items.reduce((p, c) => {
            const language = c.contentTypeLanguages[0];
            const data = [...p, { ...c, language }];
            return data;
          }, []);

          this.contentTypes = resultData;
          this.total = totalCount;
        })
        .catch((error) => {
          showSnackbarFailMessage('حدث خطأ اثناء عملية جلب البيانات');
        })
        .finally(() => this.$store.commit('loading/SET_SHOW', false));
    },
    searchUser() {},
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
};
</script>
